import { render, staticRenderFns } from "./FontCard.vue?vue&type=template&id=cf38e85c"
import script from "./FontCard.vue?vue&type=script&lang=js"
export * from "./FontCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports